import React from "react";

import styled from "styled-components";
import { BootstrapModal } from "../../../BootstrapModal/Modal";
import Button from "../../../Button/Button";
import { CgClose } from "react-icons/cg";
import { useGetProductList1 } from "../../../../hooks/useContent";
import Typography from "../../../Typography/Typography";
import { Wrapper } from "../../../../theme/GlobalStyle";
import { SimpleSelect1 } from "../../../SimpleSelect/SimpleSelect1";
import Spinner from "react-bootstrap/Spinner";
import { useEffect } from "react";

function GetCategoryLevel1({
  handleClose,
  show,
  item,
  levelsProperty,
  setLevelsProperty,
  idDefault,
}) {
  const {
    data: levelList,
    isLoading: fetchLoading,
    isFetching: fetchLoadingV2,
    isFetched,
    isError: errorReq,
  } = useGetProductList1("");

  let levelOption = levelList?.data?.categories?.map((level) => {
    return { value: level?.IdCategories, label: level?.NameCategories };
  });

  const defaultLevelOption = { value: -1, label: "دسته بندی را انتخاب کنید" };

  useEffect(() => {
    const lable = levelList?.data?.categories?.filter(
      (opt) => opt?.IdCategories === idDefault
    )[0]?.NameCategories;

    if (idDefault !== null)
      setLevelsProperty({
        ...levelsProperty,
        level1: { id: idDefault, name: lable },
      });
  }, [isFetched, idDefault]);

  levelOption?.unshift(defaultLevelOption);

  const handleLevelSelect = (event) => {
    const { value, label } = event;

    setLevelsProperty({
      ...levelsProperty,
      level1: { id: value, name: label },

      level2: { id: -1, name: "انتخاب گزینه" },
    });
    handleClose();
  };

  return (
    <BootstrapModal
      modaltitle="انتخاب دسته بندی"
      handleClose={handleClose}
      show={show}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <DeletePropertyStyle>
        {fetchLoadingV2 ? (
          <Spinner animation="border" size="sm" />
        ) : errorReq ? (
          <Typography primary={"red"}>
            مشکلی در گرفتن اطلعات پیش امده
          </Typography>
        ) : (
          <SelectContainer>
            <SimpleSelect1
              label={"دسته بندی سطح 1"}
              placeholder={"دسته بندی را انتخاب کنید"}
              res={levelOption}
              onChange={handleLevelSelect}
            />
          </SelectContainer>
        )}
      </DeletePropertyStyle>
    </BootstrapModal>
  );
}

const DeletePropertyStyle = styled.div`
  width: 100%;
  /* height: 80px; */
  height: 50vh;
  background-color: #fff;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
`;

const SelectContainer = styled.div`
  width: 100%;
`;

export default GetCategoryLevel1;
